import { getStoredToken } from "../../utils/auth";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export const PLAN_TYPES = { BROADCASTER: "broadcaster", VIEWER: "viewer" };

const request = async (path, { method = "GET", body } = {}) => {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: { "Content-Type": "application/json", token: getStoredToken() },
    ...(body && { body: JSON.stringify(body) }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    const error = new Error(data.message || "Request failed. Please try again.");
    error.status = res.status;
    throw error;
  }
  return data.result;
};

export const getPlans = (type) => request(`/subscription/plans?type=${type}`);

export const getCurrentSubscription = (type) => request(`/subscription/current?type=${type}`);

export const getSubscriptionStatus = () => request("/subscription/status");

// payment_mode "payment_gateway" returns a Stripe client_secret; the plan is activated by the payment webhook
export const subscribe = (planId, paymentMode) =>
  request("/subscription/subscribe", { method: "POST", body: { plan_id: planId, payment_mode: paymentMode } });

export const cancelSubscription = (type) => request("/subscription/cancel", { method: "POST", body: { type } });

export const cancelScheduledChange = (type) =>
  request("/subscription/cancel-scheduled-change", { method: "POST", body: { type } });

export const getWalletBalance = () => request("/wallet/balance").then((result) => Number(result.balance) || 0);

// Value of one wallet coin in `currency`; null when wallet coins can't be used for that currency right now
export const getWalletExchangeRate = (currency) =>
  request(`/wallet/exchange-rate?currency=${encodeURIComponent(currency)}`).then((result) => Number(result.exchange_rate) || null);

export const listReplays = ({ page = 1, limit = 20 } = {}) => request(`/live/replays?page=${page}&limit=${limit}`);

export const getReplay = (streamId) => request(`/live/replays/${streamId}`);
